// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2iCpO","chart":"chart__3NqlA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LineChart/styles.scss
// module id = 2133
// module chunks = 1